export default __webpack_public_path__ + "2ad7814fdf15057894c3ad69620e2b2b.svg";